import React from "react";
import { Input } from "reactstrap";

export const DefaultFilter = ({ column: { filterValue, setFilter }, testId }) => {
  return (
    <Input
      data-testid={testId}
      type="search"
      value={filterValue || ""}
      placeholder=""
      onChange={(e) => setFilter(e.target.value || undefined)}
    />
  );
};
